import React from 'react';

const Projects = () => <div></div>;

export default Projects;
